import http from '@plugin/axios'
import NoEvaluationSysTable from './components/NoEvaluationSysTable.vue'
import MarkBase from './components/MarkBase.vue'
import Form from '@utils/form'

async function getData(vm: any) {
  const params = {
    processNo: vm.$route.query.processNo,
    purchaseUnitNo: vm.$route.query.purchaseUnitNo,
    assessSystemNo: vm.$route.query.assessSystemNo,
    judgeType: vm.$route.query.judgeType
  }
  const data = await http<any>({
    url: '/examineProcess/getExamineResult',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      viewFlag: 'score',
      processNo: vm.$route.query.processNo,
      purchaseUnitNo: vm.$route.query.purchaseUnitNo
    }
  })
  vm.data.markBase = {
    mark: true,
    assessSystemName: vm.$route.query.assessSystemName,
    purchaseUnitName: vm.$route.query.purchaseUnitName,
    workingPeriodName: vm.$route.query.workingPeriodName,
    workingDateName: vm.$route.query.workingDateName,
    ...params
  }
  Reflect.set(vm.data.detailList, 'groupModel', data.groupModel)
  Reflect.set(vm.data.detailList, 'groupData', data.groupData)
  vm.createForm()
}

export default new Form('performanceAppraisal.performanceAppraisal')
  .name('PerformanceAppraisal.PerformanceAppraisal.ViewMark')
  .dataUrl(getData)
  .addGroup()
  .formItemComponent('markBase', MarkBase, {})
  .addGroup()
  .formItemComponent('detailList', NoEvaluationSysTable, {}).attrs({ disabled: true, isView: false })
  .end()
